import { render, staticRenderFns } from "./CommentButton.vue?vue&type=template&id=2ede4e43"
import script from "./CommentButton.vue?vue&type=script&lang=js"
export * from "./CommentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports